import { render, staticRenderFns } from "./MaterialLayout.vue?vue&type=template&id=73f5b70c"
import script from "./MaterialLayout.vue?vue&type=script&lang=ts"
export * from "./MaterialLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports